/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.9.1
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
import _constant from 'lodash/fp/constant';
import MultiLineString from 'ol/geom/multilinestring';
import { GEOMETRY_TYPE, geometry } from '../core';

var props = {};

var computed = {
  type: _constant(GEOMETRY_TYPE.MULTI_LINE_STRING)
};

var methods = {
  /**
   * @returns {ol.geom.MultiLineString}
   * @protected
   */
  createGeometry: function createGeometry() {
    return new MultiLineString(this.toViewProj(this.coordinates));
  }
};

var Geom = {
  name: 'vl-geom-multi-line-string',
  mixins: [geometry],
  props: props,
  computed: computed,
  methods: methods
};

var index = {
  Geom: Geom,
  install: function install(Vue) {
    Vue.component(Geom.name, Geom);
  }
};

export default index;

//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelayers/lib/multi-line-string-geom/index.es.js
// module id = null
// module chunks = 